<template>
  <app-content class="h-panel">
    <div class="flex justify-between p-20px pb-0px">
      <div class="flex">
        <span style="line-height:32px;">银行科目：</span>
        <Select :datas="subjectList" v-model="params.subjectId" style="width: 250px;margin-right: 16px" @change="handleSubjectChange" :deletable="false">
        </Select>
        <span style="line-height:32px;">截止日期：</span>
        <DatePicker v-model="params.billDate.end" :clearable="false" @change="reSearch" style="width: 120px;margin-right: 16px"/>
        <DropdownCustom ref="paramsDropdown" button class="h-btn-primary mr-20px" trigger="click">
          <div>更多筛选</div>
          <template #content>
            <Form style="padding: 10px;width: 500px">
              <FormItem class="!pb-5px" label="对账日期">
                <div class="flex items-center">
                  <DatePicker v-model="params.reconciliationDateStart"/>
                  <span class="mx-8px">至</span>
                  <DatePicker v-model="params.reconciliationDateEnd" />
                </div>
              </FormItem>
              <FormItem class="!pb-5px" label="对账编号">
                <Input v-model="params.reconciliationId"/>
              </FormItem>
              <FormItem class="!pb-10px" label="收入金额">
                <div class="flex items-center">
                  <NumberInput v-model="params.minInAmount"/>
                  <span class="mx-8px">至</span>
                  <NumberInput v-model="params.maxInAmount"/>
                </div>
              </FormItem>
              <FormItem class="!pb-10px" label="支出金额">
                <div class="flex items-center">
                  <NumberInput v-model="params.minOutAmount"/>
                  <span class="mx-8px">至</span>
                  <NumberInput v-model="params.maxOutAmount"/>
                </div>
              </FormItem>
              <FormItem class="!pb-5px">
                <Button color="primary" @click="this.$refs.paramsDropdown.hide();reSearch();" :loading="loading">确定</Button>
                <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
                <Button @click="resetForm">重置</Button>
              </FormItem>
            </Form>
          </template>
        </DropdownCustom>
      </div>
      <div class=" flex items-center">
        <Checkbox v-model="showAll" class="mr-16px" @change="handleShowAll">全部显示</Checkbox>
        <vxe-button :loading="loading" v-if="params.reconciliationId==null || params.reconciliationId==''" @click="handleRefer" icon="fa fa-eye" content="参照" size="medium"/>
        <vxe-button :loading="loading" v-else @click="handleUnRefer" icon="fa fa-eye-slash" content="取消参照" size="medium"/>
        <vxe-button :loading="loading" @click="doReconciliation" icon="fa fa-check" content="确认对账" size="medium"/>
        <vxe-button :loading="loading" @click="cancelReconciliation" icon="fa fa-reply" content="取消对账" size="medium"/>
        <vxe-button :loading="loading" @click="showCancelDialog" icon="fa fa-reply-all" content="取消全部" size="medium"/>
        <vxe-button :loading="loading" @click="autoReconciliation" icon="fa fa-desktop" content="自动对账" size="medium"/>
      </div>
    </div>
    <div class="h-panel-body">
      <div class="flex-1 mr-16px">
        <div style="padding:10px 0;">
          <span>对账单</span>
        </div>

        <vxe-table
                   height="200"
                   ref="statementTable"
                   :loading="statementLoading"
                   :row-config="{isCurrent: true, isHover: true}"
                   @current-change="currentChange"
                   :scroll-y="{enabled: true}"
                   :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                   :data="statementList"
                   @checkbox-change="statementSelectChange"
                   @checkbox-all="statementSelectChange"
                   :show-footer="showStatementFooter"
                   :footer-data="statementFooter"
                   footer-row-class-name="footer-bold"
                   :sort-config="{multiple: true, trigger: 'cell',remote: true}"
                   @sort-change="statementSortChange">
          <vxe-column type="checkbox" width="55" align="center"></vxe-column>
          <vxe-column title="对账" width="100" align="center">
            <template #default="{ row }">
              <vxe-icon name="check" v-if="row.hasOwnProperty('reconciliationId') && row.reconciliationId!=null"></vxe-icon>
            </template>
          </vxe-column>
          <vxe-column title="对账编号" v-if="showAll" field="reconciliationId" width="150"/>
          <vxe-column title="日期" field="billDate" width="120" sortable/>
          <vxe-column title="收入金额" field="inAmount" width="120" align="right" sortable>
            <template #default="{ row }">
              {{ numFormat(row.inAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="支出金额" field="outAmount" width="120" align="right" sortable>
            <template #default="{ row }">
              {{ numFormat(row.outAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="本次余额" field="currentBalance" width="120" align="right">
            <template #default="{ row }">
              {{ numFormat(row.currentBalance) }}
            </template>
          </vxe-column>
          <vxe-column title="交易备注" field="comments" width="260" align="center"/>
<!--          <vxe-column title="对方账号" field="opposingAccount" width="100"/>-->
          <vxe-column title="对方户名" field="opposingAccountName" width="100" align="center"/>
          <vxe-column title="对方开户行" field="opposingBankName" width="130" align="center"/>
          <vxe-column title="交易流水号" field="billNo" width="220" align="center"/>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="退款ID" field="djId" width="160" align="center"/>
<!--          <vxe-column title="交易时间" field="billTime" width="160"/>-->
        </vxe-table>

        <vxe-pager
            :layouts="['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'PageCount','Total']"
            v-model:current-page="pagination1.page"
            v-model:page-size="pagination1.pageSize"
            :page-sizes="[10,20,50,100,200,500]"
            :total="pagination1.total"
            @page-change="loadStatementList">
        </vxe-pager>

        <div style="padding:10px 0;">
          <span>银行账</span>
        </div>
        <vxe-table height="200"
                   ref="voucherTable"
                   :loading="voucherLoading"
                   :row-config="{isCurrent: true, isHover: true}"
                   @current-change="currentChange"
                   :scroll-y="{enabled: true}"
                   :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                   :data="voucherList"
                   @page-change="loadStatementList"
                   @checkbox-change="voucherSelectChange"
                   @checkbox-all="voucherSelectChange"
                   :show-footer="showVoucherFooter"
                   :footer-data="voucherFooter"
                   footer-row-class-name="footer-bold"
                   :sort-config="{multiple: true, trigger: 'cell',remote: true}"
                   @sort-change="voucherSortChange">
          <vxe-column type="checkbox" width="55" align="center"></vxe-column>
          <vxe-column title="对账" width="100" align="center">
            <template #default="{ row }">
              <vxe-icon name="check" v-if="row.hasOwnProperty('reconciliationId') && row.reconciliationId!=null"></vxe-icon>
            </template>
          </vxe-column>
          <vxe-column title="对账编号" v-if="showAll" field="reconciliationId" width="150"/>
          <vxe-column title="日期" field="voucherDate" width="120" sortable/>
          <vxe-column title="借方金额" field="debitAmount" width="120" align="right" sortable>
            <template #default="{ row }">
              {{ numFormat(row.debitAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="贷方金额" field="creditAmount" width="120" align="right" sortable>
            <template #default="{ row }">
              {{ numFormat(row.creditAmount) }}
            </template>
          </vxe-column>
          <vxe-column title="摘要" field="summary" width="320" align="center"/>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="案号" field="caseinfo" width="200" align="center"/>
          <vxe-column title="凭证字号" width="100" align="center">
            <template #default="{ row }">
              {{ row.word }}{{ row.code }}
            </template>
          </vxe-column>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="银行流水号" field="bankBillNo" width="220" align="center"/>
          <vxe-column v-if="currentAccountSets.intelligentReconciliation" title="单据主键" field="djId" width="220" align="center"/>


        </vxe-table>

        <vxe-pager
            :layouts="['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'PageCount', 'Total']"
            v-model:current-page="pagination2.page"
            v-model:page-size="pagination2.pageSize"
            :page-sizes="[10,20,50,100,200,500]"
            :total="pagination2.total"
            @page-change="loadVoucherList">
        </vxe-pager>


        <table class="balance-table" style="margin-top:20px;">
          <tr>
            <td style="width:180px;">银行账账面余额：</td>
            <td colspan="2" style="text-align:right;">
              <template v-if="balanceData.voucherBalance!=null && balanceData.voucherBalance!=0">{{ numFormat(balanceData.voucherBalance) }}</template>
            </td>
            <td></td>
            <td style="width:180px;">对账单余额：</td>
            <td colspan="2" style="text-align:right;">
              <template v-if="balanceData.bankBalance!=null && balanceData.bankBalance!=0">{{ numFormat(balanceData.bankBalance) }}</template>
            </td>
          </tr>
          <tr>
            <td>+:银行已收企业未收：</td>
            <td style="text-align:right;width:100px;"><template v-if="balanceData.bankInNum!=null && balanceData.bankInNum!=0">{{ balanceData.bankInNum }}笔</template></td>
            <td style="text-align:right;width:200px;"><template v-if="balanceData.bankInAmount!=null && balanceData.bankInAmount!=0">{{ numFormat(balanceData.bankInAmount) }}</template></td>
            <td></td>
            <td>+:企业已收银行未收：</td>
            <td style="text-align:right;width:100px;"><template v-if="balanceData.voucherInNum!=null && balanceData.voucherInNum!=0">{{ balanceData.voucherInNum }}笔</template></td>
            <td style="text-align:right;width:200px;"><template v-if="balanceData.voucherInAmount!=null && balanceData.voucherInAmount>0">{{ numFormat(balanceData.voucherInAmount) }}</template></td>
          </tr>
          <tr>
            <td>-:银行已付企业未付：</td>
            <td style="text-align:right;"><template v-if="balanceData.bankOutNum!=null && balanceData.bankOutNum!=0">{{ balanceData.bankOutNum }}笔</template></td>
            <td style="text-align:right;"><template v-if="balanceData.bankOutAmount!=null && balanceData.bankOutAmount>0">{{ numFormat(balanceData.bankOutAmount) }}</template></td>
            <td></td>
            <td>-:企业已付银行未付：</td>
            <td style="text-align:right;"><template v-if="balanceData.voucherOutNum!=null && balanceData.voucherOutNum!=0">{{ balanceData.voucherOutNum }}笔</template></td>
            <td style="text-align:right;"><template v-if="balanceData.voucherOutAmount!=null && balanceData.voucherOutAmount!=0">{{ numFormat(balanceData.voucherOutAmount) }}</template></td>
          </tr>
          <tr style="border-top:1px solid #ddd;">
            <td>调整后银行账余额：</td>
            <td colspan="2" style="text-align:right;">
              <template v-if="balanceData.voucherReconciliationBalance!=null && balanceData.voucherReconciliationBalance!=0">{{ numFormat(balanceData.voucherReconciliationBalance) }}</template>
            </td>
            <td></td>
            <td style="width:180px;">调整后对账单余额：</td>
            <td colspan="2" style="text-align:right;">
              <template v-if="balanceData.bankReconciliationBalance!=null && balanceData.bankReconciliationBalance!=0">{{ numFormat(balanceData.bankReconciliationBalance) }}</template>
            </td>
          </tr>
          <tr>
            <td>银行账与对账单差额：</td>
            <td colspan="2" style="text-align:right;">
              <template v-if="balanceData.reconciliationBalance!=null && balanceData.reconciliationBalance!=0">{{ numFormat(balanceData.reconciliationBalance) }}</template>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>




      </div>

    </div>
    <Loading text="请稍候..." :loading="allLoading" ></Loading>
  </app-content>

</template>

<script>

import CashierAccount from "@api/CashierAccount";
import BankStatement from "@api/BankStatement";
import voucher from "@api/voucher";
import setting from "@api/setting";
import {layer} from "@layui/layer-vue";
import {h, ref} from "vue";
import CashierAccountForm from "@/views/cashier/CashierAccountForm";
import {clone, padStart} from "xe-utils";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import bankReconciliation from "@api/BankReconciliation";
import CancelReconciliationOptions from "@/views/reconciliation/CancelReconciliationOptions";
// import {notice} from "heyui.ext";

export default {
  name: "BankReconciliation",
  data() {
    return {
      filterVal: null,
      loading: false,
      allLoading: false,
      statementLoading: false,
      voucherLoading: false,
      pagination1: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      pagination2: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      showAll: false,
      params:{
        reconciliationCompleted: false,
        billDate: {start: null, end: null},
        subjectId: null,
        reconciliationDateStart: null,
        reconciliationDateEnd: null,
        reconciliationId: null,
        minInAmount: null,
        maxInAmount: null,
        minOutAmount: null,
        maxOutAmount: null,
      },
      subjectList: [],
      statementList: [],
      showStatementFooter: false,
      statementFooter: [{billDate:'已选合计',inAmount:"",outAmount:""}],
      statementSortList: [],
      voucherList: [],
      showVoucherFooter: false,
      voucherFooter: [{voucherDate:'已选合计',debitAmount:"",creditAmount:""}],
      voucherSortList: [],
      dataList: [],
      balanceData: {
        bankBalance: 0,
        voucherBalance: 0,
        bankInNum: 0,
        bankInAmount: 0,
        voucherInNum: 0,
        voucherInAmount: 0,
        bankOutNum: 0,
        bankOutAmount: 0,
        voucherOutNum: 0,
        voucherOutAmount: 0,
        bankReconciliationBalance: 0,
        voucherReconciliationBalance: 0,
        reconciliationBalance: 0
      },
      referReconciliationId: null
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    },
    nextCode() {
      return padStart((this.typeData.length + 1) + "", 3, '0')
    }
  },
  methods: {
    loadBankSubjectList(){
      return setting.subject.bankList().then(({data}) => {
        this.subjectList = data.map(val => {

          return {
            key: val.id,
            title: val.code + ' ' + val.fullName,
            endDate: val.reconciliationEndDate ? val.reconciliationEndDate:null
          }
        })
        if(this.subjectList.length>0){
          this.params.subjectId = this.subjectList[0].key;

          if(this.subjectList[0].hasOwnProperty("endDate") && this.subjectList[0].endDate!=null && this.subjectList[0].endDate!=""){
            this.params.billDate.end = this.subjectList[0].endDate;
          }
        }
        this.cloneParams = clone(this.params, true);
      });
    },
    reSearch(){
      this.pagination1.page = 1;
      this.pagination2.page = 1;
      this.loadList();
    },
    loadList() {
      if( (this.params.reconciliationDateStart!=null && this.params.reconciliationDateStart!="")
          || (this.params.reconciliationDateEnd!=null && this.params.reconciliationDateEnd!="")
          || (this.params.reconciliationId!=null && this.params.reconciliationId!="")){
        this.showAll = true;
      }
      if(this.showAll){
        this.params.reconciliationCompleted = null;
      }else{
        this.params.reconciliationCompleted = false;
      }
      this.loadStatementList();
      this.loadVoucherList();
      this.loadReconciliationBalance();
    },
    loadStatementList(){
      this.statementLoading = true
      let params = clone(this.params, true);
      params.sortList = this.statementSortList;
      BankStatement.list(this.pagination1,params).then(({data}) => {
        this.statementList = data.results || [];
        this.pagination1.total = data.total;
      }).finally(() => {
        this.statementLoading = false;
        this.statementSelectChange();
      })
    },
    loadVoucherList(){
      this.voucherLoading = true
      let params = clone(this.params, true);
      params.voucherDate = params.billDate;
      params.sortList = this.voucherSortList;

      voucher.reconciliationList(this.pagination2, params).then(({data}) => {
        this.voucherList = data.results || [];
        this.pagination2.total = data.total;
      }).finally(() => {
        this.voucherLoading = false;
        this.voucherSelectChange();
      })
    },
    loadReconciliationBalance(){
      let params = {};
      params.subjectId = this.params.subjectId;
      params.endDate = this.params.billDate.end;
      bankReconciliation.reconciliationBalance(params).then(({data}) => {
        this.balanceData = data;

      });
    },
    statementSelectChange(){
      let footer = {billDate:'已选合计',inAmount:"",outAmount:""};
      const selectRows = this.$refs.statementTable.getCheckboxRecords();
      if(selectRows.length>0){
        this.showStatementFooter = true;
      }else{
        this.showStatementFooter = false;
      }
      let totalInAmount = 0;
      let totalOutAmount = 0;
      for(let i=0;i<selectRows.length;i++){
        totalInAmount += Math.round(selectRows[i].inAmount*10000);
        totalOutAmount += Math.round(selectRows[i].outAmount*10000);
      }
      totalInAmount = totalInAmount/10000;
      totalOutAmount = totalOutAmount/10000;
      footer.inAmount = this.numFormat(totalInAmount);
      footer.outAmount = this.numFormat(totalOutAmount);
      this.statementFooter = [footer];

    },
    voucherSelectChange(){
      let footer = {voucherDate:'已选合计',debitAmount:"",creditAmount:""};
      const selectRows = this.$refs.voucherTable.getCheckboxRecords();
      if(selectRows.length>0){
        this.showVoucherFooter = true;
      }else{
        this.showVoucherFooter = false;
      }
      let totalDebitAmount = 0;
      let totalCreditAmount = 0;
      for(let i=0;i<selectRows.length;i++){
        totalDebitAmount += Math.round(selectRows[i].debitAmount*10000);
        totalCreditAmount += Math.round(selectRows[i].creditAmount*10000);
      }
      totalDebitAmount = totalDebitAmount/10000;
      totalCreditAmount = totalCreditAmount/10000;
      footer.debitAmount = this.numFormat(totalDebitAmount);
      footer.creditAmount = this.numFormat(totalCreditAmount);
      this.voucherFooter = [footer];

    },
    statementSortChange({sortList}){
      this.statementSortList = sortList.map((item) => `${item.field} ${item.order}`);
      this.pagination1.page = 1;
      this.loadStatementList();
    },
    voucherSortChange({sortList}){
      this.voucherSortList = sortList.map((item) => `${item.field} ${item.order}`);
      this.pagination2.page = 1;
      this.loadVoucherList();
    },
    doReconciliation(){
      this.loading = true
      let params = {};
      params.subjectId = this.params.subjectId;
      params.endDate = this.params.billDate.end;
      const selectRows1 = this.$refs.statementTable.getCheckboxRecords();

      let checkDz = true;
      for(let i in selectRows1){
        let row = selectRows1[i];
        if(row.reconciliationId){
          checkDz = false;
          break;
        }
      }

      params.statementIds = selectRows1.map((row,k) => {
        return row.hasOwnProperty('id') ? row.id:null;
      });

      // if(params.statementIds.length==0){
      //   this.loading = false;
      //   this.$Message({type:"error",text:"请选择对账单数据！"});
      //   return;
      // }

      const selectRows2 = this.$refs.voucherTable.getCheckboxRecords();
      for(let i in selectRows2){
        let row = selectRows2[i];
        if(row.reconciliationId){
          checkDz = false;
          break;
        }
      }

      if(checkDz == false){
        this.loading = false;
        this.$Message({type:"error",text:"请选择未对账的数据！"});
        return;
      }

      params.voucherDetailIds = selectRows2.map((row,k) => {
        return row.hasOwnProperty('id') ? row.id:null;
      });

      // if(params.voucherDetailIds.length==0){
      //   this.loading = false;
      //   this.$Message({type:"error",text:"请选择银行账数据！"});
      //   return;
      // }

      if(params.statementIds.length==0 && params.voucherDetailIds.length==0){
        this.loading = false;
        this.$Message({type:"error",text:"请选择要对账的数据！"});
        return;
      }

      let totalInAmount = 0;
      let totalOutAmount = 0;
      for(let i=0;i<selectRows1.length;i++){
        totalInAmount += Math.round(selectRows1[i].inAmount*10000);
        totalOutAmount += Math.round(selectRows1[i].outAmount*10000);
      }

      // let inOutDiffAmount = Math.abs(totalInAmount - totalOutAmount) / 10000;
      let inOutDiffAmount = (totalInAmount - totalOutAmount) / 10000;
      totalInAmount = totalInAmount/10000;
      totalOutAmount = totalOutAmount/10000;

      let totalDebitAmount = 0;
      let totalCreditAmount = 0;
      for(let i=0;i<selectRows2.length;i++){
        totalDebitAmount += Math.round(selectRows2[i].debitAmount*10000);
        totalCreditAmount += Math.round(selectRows2[i].creditAmount*10000);
      }

      // let debitCreditDiffAmount = Math.abs(totalDebitAmount - totalCreditAmount) / 10000;
      let debitCreditDiffAmount = (totalDebitAmount - totalCreditAmount) / 10000;
      totalDebitAmount = totalDebitAmount/10000;
      totalCreditAmount = totalCreditAmount/10000;


      if(inOutDiffAmount != debitCreditDiffAmount){
        this.$Message({type:"error",text:"选择的对账单金额和银行账金额不一致！"})
        this.loading = false;
        return;
      }

      bankReconciliation.doReconciliation(params).then(({data}) => {
        this.$Message({type:"success",text:"操作完成！"})
        this.reSearch();
      }).finally(() => {
        this.loading = false;
      })
    },
    cancelReconciliation(){
      this.loading = true
      let params = {};
      params.subjectId = this.params.subjectId;
      params.endDate = this.params.billDate.end;
      const selectRows1 = this.$refs.statementTable.getCheckboxRecords();

      let checkDz = true;
      for(let i in selectRows1){
        let row = selectRows1[i];
        if(!row.reconciliationId){
          checkDz = false;
          break;
        }
      }

      params.statementIds = selectRows1.map((row,k) => {
        return row.hasOwnProperty('id') ? row.id:null;
      });

      // if(params.statementIds.length==0){
      //   this.loading = false;
      //   this.$Message({type:"error",text:"请选择对账单数据！"});
      //   return;
      // }

      const selectRows2 = this.$refs.voucherTable.getCheckboxRecords();
      for(let i in selectRows2){
        let row = selectRows2[i];
        if(!row.reconciliationId){
          checkDz = false;
          break;
        }
      }

      if(checkDz == false){
        this.loading = false;
        this.$Message({type:"error",text:"请选择已对账的数据！"});
        return;
      }

      params.voucherDetailIds = selectRows2.map((row,k) => {
        return row.hasOwnProperty('id') ? row.id:null;
      });

      // if(params.voucherDetailIds.length==0){
      //   this.loading = false;
      //   this.$Message({type:"error",text:"请选择银行账数据！"});
      //   return;
      // }

      if(params.statementIds.length==0 && params.voucherDetailIds.length==0){
        this.loading = false;
        this.$Message({type:"error",text:"请选择要对账的数据！"});
        return;
      }

      let totalInAmount = 0;
      let totalOutAmount = 0;
      for(let i=0;i<selectRows1.length;i++){
        totalInAmount += Math.round(selectRows1[i].inAmount*10000);
        totalOutAmount += Math.round(selectRows1[i].outAmount*10000);
      }

      // let inOutDiffAmount = Math.abs(totalInAmount - totalOutAmount) / 10000;
      let inOutDiffAmount = (totalInAmount - totalOutAmount) / 10000;
      totalInAmount = totalInAmount/10000;
      totalOutAmount = totalOutAmount/10000;

      let totalDebitAmount = 0;
      let totalCreditAmount = 0;
      for(let i=0;i<selectRows2.length;i++){
        totalDebitAmount += Math.round(selectRows2[i].debitAmount*10000);
        totalCreditAmount += Math.round(selectRows2[i].creditAmount*10000);
      }

      // let debitCreditDiffAmount = Math.abs(totalDebitAmount - totalCreditAmount) / 10000;
      let debitCreditDiffAmount = (totalDebitAmount - totalCreditAmount) / 10000;
      totalDebitAmount = totalDebitAmount/10000;
      totalCreditAmount = totalCreditAmount/10000;


      if(inOutDiffAmount != debitCreditDiffAmount){
        this.$Message({type:"error",text:"选择的对账单金额和银行账金额不一致！"})
        this.loading = false;
        return;
      }

      bankReconciliation.cancelReconciliation(params).then(({data}) => {
        this.$Message({type:"success",text:"取消对账完成！"})
        this.reSearch();
      }).finally(() => {
        this.loading = false;
      })
    },
    cancelAllReconciliation(){
      this.loading = true
      let params = {};
      params.subjectId = this.params.subjectId;
      params.reconciliationDateStart = this.params.reconciliationDateStart;
      params.reconciliationDateEnd = this.params.reconciliationDateEnd;


      if((params.reconciliationDateStart==null || params.reconciliationDateStart=="") && (params.reconciliationDateEnd==null || params.reconciliationDateEnd=="") ){
        this.$Message("请选择对账日期！")
        this.loading = false;
        return;
      }

      bankReconciliation.cancelAllReconciliation(params).then(({data}) => {
        this.$Message({type:"success",text:"取消对账完成！"})
        this.reSearch();
      }).finally(() => {
        this.loading = false;
      })
    },
    showCancelDialog() {
      let layerId = layer.open({
        title: "取消全部对账",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(CancelReconciliationOptions, {
          subjectList: this.subjectList,
          subjectValue: this.params.subjectId,
          reconciliationDateStart: this.params.reconciliationDateStart,
          reconciliationDateEnd: this.params.reconciliationDateEnd,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.reSearch()
          }
        })
      });
    },
    autoReconciliation(){
      this.loading = true;
      this.allLoading = true;
      // let message = this.$Message.loading(`对账进行中，请稍后...`, 0);
      let params = {};
      params.subjectId = this.params.subjectId;
      params.endDate = this.params.billDate.end;
      bankReconciliation.autoReconciliation(params).then(({data}) => {
        this.$Message({type:"success",text:"自动对账完成！"})
        this.reSearch();
      }).finally(() => {
        this.loading = false;
        this.allLoading = false;
        // message.close();
      })
    },
    currentChange(data){
      if(data.row.reconciliationId!=undefined && data.row.reconciliationId!=null){
        this.referReconciliationId = data.row.reconciliationId;
      }
    },
    handleSubjectChange(newSubject){
      if(newSubject.endDate !=undefined && newSubject.endDate !=null && newSubject.endDate !=""){
        this.params.billDate.end = newSubject.endDate;
      }
      this.reSearch();
    },
    handleShowAll(newValue){
      this.showAll = newValue;
      this.reSearch();
    },
    handleRefer(){
      if(this.referReconciliationId!=null){
        this.params.reconciliationId = this.referReconciliationId;
      }
      this.reSearch();
    },
    handleUnRefer(){
      this.params.reconciliationId = null;
      this.reSearch();
    },
    showForm(entity = null) {
      let layerId = layer.open({
        title: "账户信息",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['400px', 'auto'],
        content: h(CashierAccountForm, {
          entity,
          type: this.tab,
          nextCode: this.nextCode,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            this.loadList();
            layer.close(layerId);
          }
        })
      });
    },
    remove(row) {
      this.$Confirm("确认删除?").then(() => {
        this.loading = true;
        CashierAccount.delete(row.id).then(() => {
          this.reSearch();
        }).finally(() => this.loading = true)
      })
    },
    resetForm() {
      this.showAll = false;
      this.params = clone(this.cloneParams, true)
    }
  },
  created() {
    const currentAccountDate = manba(this.currentAccountSets.currentAccountDate);
    const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
    const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());
    const now = manba();
    this.params.billDate.end = now.add(-1,manba.MONTH).endOf(manba.MONTH).format();
    this.cloneParams = clone(this.params, true);

    this.loadBankSubjectList().then(() => {
      this.loadList();
    });
  }
}
</script>
<style>
.balance-table{
  border:1px solid #ddd;
  width:100%;
  border-collapse: collapse;
}
.balance-table td{
  padding:5px 10px;
}
.footer-bold{
  font-weight:bold;
  font-size:14px;
}
</style>
